import * as React from "react";
import { Route, Switch } from "react-router";

import AdminLayout from "./components/admin/AdminLayout";
import PrivateRoute from "./components/admin/PrivateRoute";
import Login from "./components/admin/Login";
import MainLayout from "./components/main/MainLayout";

import "./custom.css";

const App: React.FC = () => {
  return (
    <Switch>
      <Route exact path="/login" component={Login} />
      <PrivateRoute exact path={["/admin/*"]} component={AdminLayout} />
      <Route exact path={["/", "/gallery/*"]} component={MainLayout} />
      <Route path="*" render={() => <div>page not found!!!</div>} />
    </Switch>
  );
};

export default App;
